import React from 'react'
import styles from './PreviewModal.module.scss'
import { XMarkIcon } from '@heroicons/react/24/solid'
import { useAuthStatus } from '../../utils'
import { formatPrizeTypeLabel, INCENTIVE_BASIS_LABEL } from '../../utils/incentiveDisplay'
import axios from 'axios'
import { useState } from 'react'
import { useEffect, useRef, useCallback } from 'react'

const PreviewModal = ({ isOpen, onClose, writtenData, data, timePassed }) => {
	const [authStatus] = useAuthStatus()
	const [displayIconContent, setDisplayIconContent] = React.useState(null)
	const [salaryDisplayContent, setSalaryDisplayContent] = React.useState(null)
	const [domesticOverseasSwapContent, setDomesticOverseasSwapContent] = useState(true)
	const [mainTitle, setMainTitle] = useState(null)
	const [userName, setUserName] = useState(null)
	const [tourCategory, setTourCategory] = useState(null)
	const [jobPostTitle, setJobPostTitle] = useState(null)
	const [jobPostBrief, setJobPostBrief] = useState(null)
	const [isOverSeasIncluded, setIsOverSeasIncluded] = useState(false)

	useEffect(() => {
		console.log('data:', data)
		console.log('timePassed:', timePassed)
		// setData(data)
		// setTimePassed(timePassed)
	}, [data, timePassed])

	useEffect(() => {
		data?.tours?.forEach((tour) => {
			if (tour.region === 'INTERNATIONAL') {
				setIsOverSeasIncluded(true)
			}
		})
	}, [data])

	const modalRef = useRef(null)

	const sortTourByDate = (tours) => {
		if (!tours || !Array.isArray(tours)) {
			return []
		}
		return tours.sort((a, b) => {
			const startDateA = new Date(a.startedAt)
			const startDateB = new Date(b.startedAt)

			// 시작 날짜가 다르면 시작 날짜로 정렬 (빠른 순)
			if (startDateA.getTime() !== startDateB.getTime()) {
				return startDateA - startDateB
			}

			// 시작 날짜가 같으면 끝나는 날짜로 정렬 (빨리 끝나는 순)
			const endDateA = new Date(a.endedAt)
			const endDateB = new Date(b.endedAt)
			return endDateA - endDateB
		})
	}

	const sortIncentiveSettings = useCallback((incentiveSettings) => {
		if (!incentiveSettings || !Array.isArray(incentiveSettings)) {
			return []
		}

		const sorted = incentiveSettings.sort((a, b) => {
			// startRank가 null이나 undefined인 경우 처리
			const aRank = a.startRank || 999
			const bRank = b.startRank || 999
			return aRank - bRank
		})

		return sorted
	}, [])

	useEffect(() => {
		const handleClickOutside = (event) => {
			// 미리보기 버튼 클릭은 무시
			if (
				event.target.closest('button') &&
				event.target.closest('button').textContent === '미리보기'
			) {
				return
			}

			if (modalRef.current && !modalRef.current.contains(event.target)) {
				onClose()
			}
		}

		if (isOpen) {
			document.addEventListener('mousedown', handleClickOutside)
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside)
		}
	}, [isOpen, onClose])

	React.useEffect(() => {
		if (!isOpen) return

		const fetchDisplayIcon = async () => {
			const content = await renderDisplayIcon()
			setDisplayIconContent(content)
		}
		const fetchSalaryDisplay = async () => {
			const content = await renderSalaryDisplay()
			setSalaryDisplayContent(content)
		}
		fetchDisplayIcon()
		fetchSalaryDisplay()
	}, [isOpen])

	useEffect(() => {
		const setDataForRender = () => {
			if (!data || !writtenData) return

			const { jobPostTitle, jobPostBrief } = writtenData

			const defineMainTitle = () => {
				console.log('jobPostTitle:', jobPostTitle)

				if (data?.contractType === 'single') {
					return '[단기계약] ' + (jobPostTitle || '제목 없음')
				} else if (data?.contractType === 'long_term') {
					return '[장기계약] ' + (jobPostTitle || '제목 없음')
				} else if (
					data?.contractType &&
					(data?.contractType === 'year_first_half' ||
						data?.contractType === 'year_second_half' ||
						data?.contractType === 'both')
				) {
					return '[기간계약] ' + (jobPostTitle || '제목 없음')
				}
				return jobPostTitle || '제목 없음'
			}

			const mainTitle = defineMainTitle()
			console.log('mainTitle:', mainTitle)

			// 투어 데이터 집합 처리
			const tourCategory = processTourDataCategory(data?.tours)

			setUserName(data?.writerName || '')
			setJobPostTitle(jobPostTitle)
			setJobPostBrief(jobPostBrief)
			setTourCategory(tourCategory)
			setMainTitle(mainTitle)
		}
		setDataForRender()
	}, [data, writtenData])

	if (!isOpen) return null

	// 천원단위 포맷팅 함수
	const formatNumber = (num) => {
		if (!num) return '0'
		return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
	}

	// 날짜에서 년도 앞 두 글자 제거 함수
	const formatYear = (dateString) => {
		if (!dateString) return ''
		// YYYY-MM-DD 형식에서 YYYY를 YY로 변환 (앞 두 글자 제거)
		return dateString.replace(/^\d{2}(\d{2}-)/, '$1')
	}

	// 투어 데이터 집합 처리 함수
	const processTourDataCategory = (selectedToursData) => {
		if (!selectedToursData || selectedToursData.length === 0) return []

		// 투어 타입별 집합 (중복 제거)
		const types = [...new Set(selectedToursData.map((tour) => tour.type))]

		return types
	}

	const renderSalaryDisplay = async () => {
		if (
			data?.contractType === 'year_first_half' ||
			data?.contractType === 'year_second_half' ||
			data?.contractType === 'both'
		) {
			const periodSalary = data?.termContract?.salaryAmountForPeriod || '0'
			return (
				<div className={styles.periodSalaryDisplayContainer}>
					<span className={styles.periodSalaryDisplayIcon}>기간급여액</span>
					<span className={styles.moneyDisplay}>{formatNumber(periodSalary)} 원</span>
				</div>
			)
		} else if (data?.domesticContract !== null) {
			const cutPass = data?.domesticContract?.weeklySalaryCutThrough || '0'
			const cutOut = data?.domesticContract?.weeklySalaryCutFail || '0'
			return (
				<div className={styles.cutDisplayContainer}>
					<div className={styles.cutPassDisplayContainer}>
						<span className={styles.cutPassDisplayIcon}>컷통과</span>
						<span className={styles.cutMoneyDisplay}>
							<span className={styles.moneyDisplayText}>{formatNumber(cutPass)}</span>
							<span className={styles.moneyDisplayText}>원</span>
						</span>
					</div>
					<div className={styles.cutOutDisplayContainer}>
						<span className={styles.cutOutDisplayIcon}>컷탈락</span>
						<span className={styles.cutMoneyDisplay}>
							<span className={styles.moneyDisplayText}>{formatNumber(cutOut)}</span>
							<span className={styles.moneyDisplayText}>원</span>
						</span>
					</div>
				</div>
			)
		} else if (data?.overseasContract !== null) {
			const cutPass = data?.overseasContract?.weeklySalaryCutThrough || '0'
			const cutOut = data?.overseasContract?.weeklySalaryCutFail || '0'
			return (
				<div className={styles.cutDisplayContainer}>
					<div className={styles.cutPassDisplayContainer}>
						<span className={styles.cutPassDisplayIcon}>컷통과</span>
						<span className={styles.cutMoneyDisplay}>
							<span className={styles.moneyDisplayText}>{formatNumber(cutPass)}</span>
							<span className={styles.moneyDisplayText}>원</span>
						</span>
					</div>
					<div className={styles.cutOutDisplayContainer}>
						<span className={styles.cutOutDisplayIcon}>컷탈락</span>
						<span className={styles.cutMoneyDisplay}>
							<span className={styles.moneyDisplayText}>{formatNumber(cutOut)}</span>
							<span className={styles.moneyDisplayText}>원</span>
						</span>
					</div>
				</div>
			)
		}
	}

	const renderDisplayIcon = async () => {
		const cutPass =
			data?.domesticContract?.weeklySalaryCutThrough ||
			data?.overseasContract?.weeklySalaryCutThrough
		const cutOut =
			data?.domesticContract?.weeklySalaryCutFail ||
			data?.overseasContract?.weeklySalaryCutFail

		if (data?.contractType === 'single') {
			return (
				<>
					<span className={styles.displayIcon}>단기계약</span>
					{data?.domesticContract !== null && (
						<span className={styles.displayIcon}>
							{data?.domesticContract?.payRollCycles === 'weekly' ? '주급' : '일시불'}
						</span>
					)}
					{data?.domesticContract === null && data?.overseasContract !== null && (
						<span className={styles.displayIcon}>
							{data?.overseasContract?.payRollCycles === 'weekly' ? '주급' : '일시불'}
						</span>
					)}
					{/* {cutOut && cutPass && (
							<span className={styles.displayIcon}>
								{data?.overseasContract?.payRollCycles === 'weekly'
									? '주급'
									: '일시불'}
							</span>
						)} */}
					{cutOut && cutPass && (
						<span className={styles.displayIcon}>
							{formatNumber(cutPass)} 원 / {formatNumber(cutOut)} 원
						</span>
					)}
				</>
			)
		} else if (data?.contractType === 'long_term') {
			// const hasWeekly =
			// 	(data?.domesticContract !== null &&
			// 		data?.domesticContract?.payRollCycles === 'weekly') ||
			// 	(data?.overseasContract !== null &&
			// 		data?.overseasContract?.payRollCycles === 'weekly')
			// const hasOneTime =
			// 	(data?.domesticContract !== null &&
			// 		data?.domesticContract?.payRollCycles === 'oneTime') ||
			// 	(data?.overseasContract !== null &&
			// 		data?.overseasContract?.payRollCycles === 'oneTime')

			return (
				<>
					<span className={styles.displayIcon}>장기계약</span>
					{data?.domesticContract !== null && (
						<span className={styles.displayIcon}>
							{data?.domesticContract?.payRollCycles === 'weekly' ? '주급' : '일시불'}
						</span>
					)}
					{data?.domesticContract === null && data?.overseasContract !== null && (
						<span className={styles.displayIcon}>
							{data?.overseasContract?.payRollCycles === 'weekly' ? '주급' : '일시불'}
						</span>
					)}
					{cutOut && cutPass && (
						<span className={styles.displayIcon}>
							{formatNumber(cutPass)} 원 / {formatNumber(cutOut)} 원
						</span>
					)}
				</>
			)
		} else if (
			data?.contractType === 'year_first_half' ||
			data?.contractType === 'year_second_half' ||
			data?.contractType === 'both'
		) {
			return (
				<>
					<span className={styles.displayIcon}>기간계약</span>
					{data?.termContract?.payRollCycles === 'weekly' ? (
						<span className={styles.displayIcon}>주급</span>
					) : (
						<span className={styles.displayIcon}>일시불</span>
					)}
				</>
			)
		}
	}

	return (
		<div
			className={styles.previewModalContainer}
			ref={modalRef}
			onClick={(e) => e.stopPropagation()}>
			<div className={styles.XButtonContainer}>
				<XMarkIcon className={styles.XMark} onClick={onClose} />
			</div>
			<div className={styles.nameHeader}>
				<div className={styles.names}>
					<img src={'/images/postPreview.png'} className={styles.previewImage} />
					<span className={styles.name}>{userName} 선수</span>
				</div>
				<span className={styles.time}>{timePassed} </span>
			</div>
			<div className={styles.mainHeader}>
				<div
					className={`${styles.mainTitle} ${!jobPostTitle || mainTitle === '제목 없음' ? styles.mainTitleEmpty : ''}`}>
					{mainTitle}
				</div>
			</div>
			<div className={styles.displayIconContainer}>{displayIconContent}</div>
			<div className={styles.salaryDisplayContainer}>{salaryDisplayContent}</div>
			<div className={styles.jobPostIntroHeader}>공고소개</div>
			<div className={styles.jobPostIntroContent}>{jobPostBrief}</div>
			<div className={styles.basicContractInfoHeader}>기본 계약정보</div>
			<div className={styles.basicContractInfoTourType}>
				<div className={styles.basicLabel}>투어종류</div>
				<div className={styles.basicContent}>
					{tourCategory?.length === 1 ? tourCategory[0] : tourCategory?.join(', ')}
				</div>
			</div>
			<div className={styles.basicContractInfoContractType}>
				<div className={styles.basicLabel}>계약유형</div>
				<div className={styles.basicContent}>
					{data?.contractType === 'single'
						? '단기계약'
						: data?.contractType === 'long_term'
							? '장기계약'
							: '기간계약'}
				</div>
			</div>
			<div
				className={
					data?.contractType === 'year_first_half' ||
					data?.contractType === 'year_second_half' ||
					data?.contractType === 'both'
						? styles.generalContractPeriodContainer
						: styles.nonGeneralContractPeriodContainer
				}>
				<div className={styles.periodLabel}>계약기간</div>
				<div className={styles.periodContent}>
					{data?.contractType === 'both'
						? '상반기 / 하반기'
						: data?.contractType === 'year_first_half'
							? '상반기'
							: data?.contractType === 'year_second_half'
								? '하반기'
								: ''}
					{(data?.contractType === 'single' ||
						(data?.contractType === 'long_term' && data?.tours?.length > 0)) && (
						<>
							{data?.tours[0]?.startedAt.slice(0, 10)} ~ <br />
							{data?.tours[data?.tours.length - 1]?.endedAt.slice(0, 10)}
						</>
					)}
				</div>
			</div>
			<div className={styles.tourListContainer}>
				<div className={styles.tourListLabel}>대회목록</div>
				<div className={styles.tourListContent}>
					{(!data?.tours || data?.tours.length === 0) && '미정'}
					{data?.tours?.length > 0 &&
						sortTourByDate(data?.tours).map((tour, index) => (
							<div key={index} className={styles.tourListItemContainer}>
								<div className={styles.tourListItemIndex}>({index + 1})</div>
								<div className={styles.tourListItemMain}>
									<div className={styles.tourName}>{tour.name}</div>
									<div className={styles.tourDate}>
										{formatYear(tour.startedAt.slice(0, 10))} ~{' '}
										{formatYear(tour.endedAt.slice(0, 10))}
									</div>
								</div>
							</div>
						))}
				</div>
			</div>
			<div className={styles.isOverSeasTourIncludeContainer}>
				<div className={styles.isOverSeasTourIncludeLabel}>해외 대회 포함 여부</div>
				<div className={styles.isOverSeasTourIncludeContent}>
					{isOverSeasIncluded ? '해외대회 포함' : '해외대회 미포함'}
				</div>
			</div>
			<div className={styles.detailContractHeader}>상세 계약정보</div>
			{(data?.contractType === 'year_first_half' ||
				data?.contractType === 'year_second_half' ||
				data?.contractType === 'both') && (
				<>
					<div className={styles.applyTaxContainer}>
						<div className={styles.applyTaxLabel}>세금 적용 여부</div>
						<div className={styles.applyTaxContent}>
							{data?.termContract?.isSalaryTaxIncluded ? '세후' : '세전'}
						</div>
					</div>
					<div className={styles.payPeriodContainer}>
						<div className={styles.payPeriodLabel}>임금 지급 주기</div>
						<div className={styles.payPeriodContent}>
							{data?.termContract?.payRollCycles === 'weekly' ? '주급' : '일시불제'}
						</div>
					</div>
					<div className={styles.periodSalaryContainer}>
						<div className={styles.periodSalaryLabel}>기간 급여액</div>
						<div className={styles.periodSalaryContent}>
							{formatNumber(data?.termContract?.salaryAmountForPeriod)} 원
						</div>
					</div>
					<div className={styles.incentiveOptionContainer}>
						<div className={styles.incentiveOptionLabel}>{INCENTIVE_BASIS_LABEL}</div>
						<div className={styles.incentiveOptionContent}>
							{formatPrizeTypeLabel(data?.termContract?.prizeType)}
						</div>
					</div>
					<div className={styles.incentiveSettingsContainer}>
						<div className={styles.incentiveSettingsLabel}>인센티브 금액</div>
						<div className={styles.incentiveSettingsContent}>
							{sortIncentiveSettings(data?.termContract?.incentives).map(
								(setting) => {
									let cut = null
									if (setting.percentage === null && setting.endRank === null)
										return null
									if (setting.endRank === 0) {
										cut = 'CUT'
									}
									const displayRank =
										setting.endRank === 1
											? '우승 : '
											: setting.startRank +
												(setting.endRank !== null
													? ` ~ ${cut || setting.endRank} :  `
													: '~ ')
									const displayPercentage =
										setting.percentage !== null
											? `  ${setting.percentage}%`
											: '미입력'
									return (
										<div
											key={setting.id}
											className={styles.incentiveDisplayItem}>
											<div>{displayRank}</div>
											<div>{displayPercentage}</div>
										</div>
									)
								},
							)}
						</div>
					</div>
					<div className={styles.wearSponserHatContainer}>
						<div className={styles.wearSponserHatLabel}>스폰서 모자 착용 여부</div>
						<div className={styles.wearSponserHatContent}>
							{data?.termContract?.wearSponsoredHat ? '착용' : '미착용'}
						</div>
					</div>
				</>
			)}
			{data?.domesticContract !== null && data?.overseasContract !== null && (
				<>
					<div className={styles.domesticOverseasSwapContainer}>
						<button
							className={
								domesticOverseasSwapContent
									? styles.seeDomesticChosen
									: styles.seeDomesticUnchosen
							}
							onClick={() => setDomesticOverseasSwapContent((prev) => !prev)}>
							국내
						</button>
						<button
							className={
								domesticOverseasSwapContent
									? styles.seeOverseasUnchosen
									: styles.seeOverseasChosen
							}
							onClick={() => setDomesticOverseasSwapContent((prev) => !prev)}>
							해외
						</button>
					</div>
					{domesticOverseasSwapContent && (
						<>
							<div className={styles.applyTaxContainer}>
								<div className={styles.applyTaxLabel}>세금 적용 여부</div>
								<div className={styles.applyTaxContent}>
									{data?.domesticContract?.isSalaryTaxIncluded ? '세후' : '세전'}
								</div>
							</div>
							<div className={styles.payPeriodContainer}>
								<div className={styles.payPeriodLabel}>임금 지급 주기</div>
								<div className={styles.payPeriodContent}>
									{data?.domesticContract?.payRollCycles === 'weekly'
										? '주급'
										: '일시불제'}
								</div>
							</div>
							<div className={styles.cutPassContainer}>
								<div className={styles.cutPassLabel}>컷통과</div>
								<div className={styles.cutPassContent}>
									{formatNumber(data?.domesticContract?.weeklySalaryCutThrough)}{' '}
									원
								</div>
							</div>
							<div className={styles.cutOutContainer}>
								<div className={styles.cutOutLabel}>컷탈락</div>
								<div className={styles.cutOutContent}>
									{formatNumber(data?.domesticContract?.weeklySalaryCutFail)} 원
								</div>
							</div>
							<div className={styles.incentiveOptionContainer}>
								<div className={styles.incentiveOptionLabel}>
									{INCENTIVE_BASIS_LABEL}
								</div>
								<div className={styles.incentiveOptionContent}>
									{formatPrizeTypeLabel(data?.domesticContract?.prizeType)}
								</div>
							</div>
							<div className={styles.incentiveSettingsContainer}>
								<div className={styles.incentiveSettingsLabel}>인센티브 금액</div>
								<div className={styles.incentiveSettingsContent}>
									{sortIncentiveSettings(data?.domesticContract?.incentives).map(
										(setting) => {
											if (
												setting.percentage === null &&
												setting.endRank === null
											)
												return null
											let cut = null
											if (setting.endRank === 0) {
												cut = 'CUT'
											}
											const displayRank =
												setting.endRank === 1
													? '우승 : '
													: setting.startRank +
														(setting.endRank !== null
															? ` ~ ${cut || setting.endRank} :  `
															: '~ ')
											const displayPercentage =
												setting.percentage !== null
													? `  ${setting.percentage}%`
													: '미입력'
											return (
												<div
													key={setting.id}
													className={styles.incentiveDisplayItem}>
													<div>{displayRank}</div>
													<div>{displayPercentage}</div>
												</div>
											)
										},
									)}
								</div>
							</div>
							<div className={styles.wearSponserHatContainer}>
								<div className={styles.wearSponserHatLabel}>
									스폰서 모자 착용 여부
								</div>
								<div className={styles.wearSponserHatContent}>
									{data?.domesticContract?.wearSponsoredHat ? '착용' : '미착용'}
								</div>
							</div>
						</>
					)}
					{!domesticOverseasSwapContent && (
						<>
							<div className={styles.applyTaxContainer}>
								<div className={styles.applyTaxLabel}>세금 적용 여부</div>
								<div className={styles.applyTaxContent}>
									{data?.overseasContract?.isSalaryTaxIncluded ? '세후' : '세전'}
								</div>
							</div>
							<div className={styles.payPeriodContainer}>
								<div className={styles.payPeriodLabel}>임금 지급 주기</div>
								<div className={styles.payPeriodContent}>
									{data?.overseasContract?.payRollCycles === 'weekly'
										? '주급'
										: '일시불제'}
								</div>
							</div>
							<div className={styles.cutPassContainer}>
								<div className={styles.cutPassLabel}>컷통과</div>
								<div className={styles.cutPassContent}>
									{formatNumber(data?.overseasContract?.weeklySalaryCutThrough)}{' '}
									원
								</div>
							</div>
							<div className={styles.cutOutContainer}>
								<div className={styles.cutOutLabel}>컷탈락</div>
								<div className={styles.cutOutContent}>
									{formatNumber(data?.overseasContract?.weeklySalaryCutFail)} 원
								</div>
							</div>
							<div className={styles.incentiveOptionContainer}>
								<div className={styles.incentiveOptionLabel}>
									{INCENTIVE_BASIS_LABEL}
								</div>
								<div className={styles.incentiveOptionContent}>
									{formatPrizeTypeLabel(data?.overseasContract?.prizeType)}
								</div>
							</div>
							<div className={styles.incentiveSettingsContainer}>
								<div className={styles.incentiveSettingsLabel}>인센티브 금액</div>
								<div className={styles.incentiveSettingsContent}>
									{sortIncentiveSettings(data?.overseasContract?.incentives).map(
										(setting) => {
											if (
												setting.percentage === null &&
												setting.endRank === null
											)
												return null
											let cut = null
											if (setting.endRank === 0) {
												cut = 'CUT'
											}
											const displayRank =
												setting.endRank === 1
													? '우승 : '
													: setting.startRank +
														(setting.endRank !== null
															? ` ~ ${cut || setting.endRank} :  `
															: '~ ')
											const displayPercentage =
												setting.percentage !== null
													? `  ${setting.percentage}%`
													: '미입력'
											return (
												<div
													key={setting.id}
													className={styles.incentiveDisplayItem}>
													<div>{displayRank}</div>
													<div>{displayPercentage}</div>
												</div>
											)
										},
									)}
								</div>
							</div>
							<div className={styles.wearSponserHatContainer}>
								<div className={styles.wearSponserHatLabel}>
									스폰서 모자 착용 여부
								</div>
								<div className={styles.wearSponserHatContent}>
									{data?.overseasContract?.wearSponsoredHat ? '착용' : '미착용'}
								</div>
							</div>
						</>
					)}
				</>
			)}

			{data?.overseasContract !== null && data?.domesticContract === null && (
				<>
					<div className={styles.applyTaxContainer}>
						<div className={styles.applyTaxLabel}>세금 적용 여부</div>
						<div className={styles.applyTaxContent}>
							{data?.overseasContract?.isSalaryTaxIncluded ? '세후' : '세전'}
						</div>
					</div>
					<div className={styles.payPeriodContainer}>
						<div className={styles.payPeriodLabel}>임금 지급 주기</div>
						<div className={styles.payPeriodContent}>
							{data?.overseasContract?.payRollCycles === 'weekly'
								? '주급'
								: '일시불제'}
						</div>
					</div>
					<div className={styles.cutPassContainer}>
						<div className={styles.cutPassLabel}>컷통과</div>
						<div className={styles.cutPassContent}>
							{formatNumber(data?.overseasContract?.weeklySalaryCutThrough)} 원
						</div>
					</div>
					<div className={styles.cutOutContainer}>
						<div className={styles.cutOutLabel}>컷탈락</div>
						<div className={styles.cutOutContent}>
							{formatNumber(data?.overseasContract?.weeklySalaryCutFail)} 원
						</div>
					</div>
					<div className={styles.incentiveOptionContainer}>
						<div className={styles.incentiveOptionLabel}>{INCENTIVE_BASIS_LABEL}</div>
						<div className={styles.incentiveOptionContent}>
							{formatPrizeTypeLabel(data?.overseasContract?.prizeType)}
						</div>
					</div>
					<div className={styles.incentiveSettingsContainer}>
						<div className={styles.incentiveSettingsLabel}>인센티브 금액</div>
						<div className={styles.incentiveSettingsContent}>
							{sortIncentiveSettings(data?.overseasContract?.incentives).map(
								(setting) => {
									if (setting.percentage === null && setting.endRank === null)
										return null
									let cut = null
									if (setting.endRank === 0) {
										cut = 'CUT'
									}
									const displayRank =
										setting.endRank === 1
											? '우승 : '
											: setting.startRank +
												(setting.endRank !== null
													? ` ~ ${cut || setting.endRank} :  `
													: '~ ')
									const displayPercentage =
										setting.percentage !== null
											? `  ${setting.percentage}%`
											: '미입력'
									return (
										<div
											key={setting.id}
											className={styles.incentiveDisplayItem}>
											<div>{displayRank}</div>
											<div>{displayPercentage}</div>
										</div>
									)
								},
							)}
						</div>
					</div>
					<div className={styles.wearSponserHatContainer}>
						<div className={styles.wearSponserHatLabel}>스폰서 모자 착용 여부</div>
						<div className={styles.wearSponserHatContent}>
							{data?.overseasContract?.wearSponsoredHat ? '착용' : '미착용'}
						</div>
					</div>
				</>
			)}
			{data?.domesticContract !== null && data?.overseasContract === null && (
				<>
					<div className={styles.applyTaxContainer}>
						<div className={styles.applyTaxLabel}>세금 적용 여부</div>
						<div className={styles.applyTaxContent}>
							{data?.domesticContract?.isSalaryTaxIncluded ? '세후' : '세전'}
						</div>
					</div>
					<div className={styles.payPeriodContainer}>
						<div className={styles.payPeriodLabel}>임금 지급 주기</div>
						<div className={styles.payPeriodContent}>
							{data?.domesticContract?.payRollCycles === 'weekly'
								? '주급'
								: '일시불제'}
						</div>
					</div>
					<div className={styles.cutPassContainer}>
						<div className={styles.cutPassLabel}>컷통과</div>
						<div className={styles.cutPassContent}>
							{formatNumber(data?.domesticContract?.weeklySalaryCutThrough)} 원
						</div>
					</div>
					<div className={styles.cutOutContainer}>
						<div className={styles.cutOutLabel}>컷탈락</div>
						<div className={styles.cutOutContent}>
							{formatNumber(data?.domesticContract?.weeklySalaryCutFail)} 원
						</div>
					</div>
					<div className={styles.incentiveOptionContainer}>
						<div className={styles.incentiveOptionLabel}>{INCENTIVE_BASIS_LABEL}</div>
						<div className={styles.incentiveOptionContent}>
							{formatPrizeTypeLabel(data?.domesticContract?.prizeType)}
						</div>
					</div>
					<div className={styles.incentiveSettingsContainer}>
						<div className={styles.incentiveSettingsLabel}>인센티브 금액</div>
						<div className={styles.incentiveSettingsContent}>
							{sortIncentiveSettings(data?.domesticContract?.incentives).map(
								(setting) => {
									if (setting.percentage === null && setting.endRank === null)
										return null
									let cut = null
									if (setting.endRank === 0) {
										cut = 'CUT'
									}
									const displayRank =
										setting.endRank === 1
											? '우승 : '
											: setting.startRank +
												(setting.endRank !== null
													? ` ~ ${cut || setting.endRank} :  `
													: '~ ')
									const displayPercentage =
										setting.percentage !== null
											? `  ${setting.percentage}%`
											: '미입력'
									return (
										<div
											key={setting.id}
											className={styles.incentiveDisplayItem}>
											<div>{displayRank}</div>
											<div>{displayPercentage}</div>
										</div>
									)
								},
							)}
						</div>
					</div>
					<div className={styles.wearSponserHatContainer}>
						<div className={styles.wearSponserHatLabel}>스폰서 모자 착용 여부</div>
						<div className={styles.wearSponserHatContent}>
							{data?.domesticContract?.wearSponsoredHat ? '착용' : '미착용'}
						</div>
					</div>
				</>
			)}
			<div className={styles.authorHeader}>작성자 정보</div>
			<div className={styles.author}>{userName + ' / ' + data?.userAssociation}</div>
		</div>
	)
}

export default PreviewModal
